import { CSSProperties } from 'react';
import { Box } from '@mui/material';

import AgTypography from '../Styles/AgTypography';

import { AgColor } from '../Styles/AgColor';

export interface itemsType {
  id: string;
  title: string;
  subTitle: string;
  isActive?: boolean;
  onClick?: () => void;
}

const AgProgressTabs = ({ items, sx }: { items: itemsType[]; sx?: CSSProperties; }) => {
  const renderItems = (stepNumber: number, item: itemsType) => {
    return (
      <Box
        key={stepNumber}
        onClick={item.onClick}
        sx={{
          width: `${90 / items.length}%`,
          maxWidth: '216px',
          minWidth: '143px',
          padding: '0px',
          gap: '16px',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer'
        }}
      >
        <Box
          sx={{
            height: 'fit-content',
            padding: '0px',
            position: 'relative',
            width: '100%'
          }}>
          <AgTypography
            contentStyle='AP.Assistive.Text.SemiBold' style={{ color: item.isActive ? AgColor.secondaryDark : AgColor.grey9, lineHeight: '16px' }}
            component='p'>{item.title}</AgTypography>
          <AgTypography
            contentStyle='AP.Assistive.Text.Regular'
            style={{ color: item.isActive ? AgColor.secondaryDark : AgColor.grey7, lineHeight: '16px', width: '100%' }}
            component='p'>{item.subTitle}</AgTypography>
        </Box>
        {
          // Tab divider
          stepNumber !== items.length ? ( <Box sx={{ height: '100%', width: '1px', bgcolor: AgColor.grey3 }}></Box> ) : null
        }
      </Box>);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        borderRadius: '8px',
        border: `.75px solid ${AgColor.grey3}`,
        boxShadow: '0 2px 1px 0px rgba(0,0,0,0.04)', 
        padding: '16px',
        gap: '16px',
        height: 'fit-content',
        alignItems: 'center',
        overflowY: 'auto',
        ...sx
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flex: '1 0 auto',
          flexWrap: 'wrap',
          minWidth: '0',
          gap: '16px'
        }}
      >
        {items.map((i, index) => renderItems(index + 1, i))}
      </Box>
    </Box>
  );
};

export default AgProgressTabs;